module.exports = __webpack_public_path__ + "static/media/mid.39806cc8.mp4";